// COPIA DICHIARATA da TMA#746 (briscola-orcb-8-tma) @ e823c650454b6adf11046bffc675774d6429937d: src/lib/briscola/gioco.ts, righe 25-27 (LIVELLI_ROBOT, LivelloRobot) e 55-67 (eRobotNonDisponibili).
// Origine: il «contro i robot» della briscola, su origin/main 47da9d56 quando e stata copiata. Nessun import dalla zona della briscola: se la briscola cambia, questa copia non lo
// sa (la riallinea chi lo decide, non un import). Cosa e diverso dall'originale: niente, tranne i commenti, che parlano della scopa.
//
// Il «contro i robot» della scopa e dello scopone (I-1017, Luca L-3534 (a): il robot SU RICHIESTA): un tavolo casual col campo `robot: { livello }` nel corpo di
// `POST /v1/games/scopa/tables` (v. `creaTavoloBody` in `rest.ts`). Chi crea siede a un posto estratto dal core e OGNI altro posto e un robot del pool, col badge «bot»:
// nella scopa e uno, nello scopone sono tre. Il game host rifiuta il campo finche QScopa non ha `robotAllaNascita` acceso e il mirror 0.2.x di app-qscopa non e su Limulo
// staging (kb#432): la TMA lo manda SOLO quando chi gioca sceglie un livello.

/** I tre livelli del robot (contratto I-833): il nome visibile e `livello.<L>` nel catalogo. */
export const LIVELLI_ROBOT = ['L0', 'L1', 'L2'] as const;
export type LivelloRobot = (typeof LIVELLI_ROBOT)[number];

/**
 * Il 503 di «Contro i robot»: il core risponde `503 no_robot_available` quando il pool del gioco non ha abbastanza account liberi, e nessun tavolo nasce. Si riconosce dallo status
 * E dal codice (ovunque stia nel corpo dell'errore: `code`, `error.code`, `message`): un ALTRO 503 (il servizio che non risponde) resta un guasto generico.
 */
export function eRobotNonDisponibili(errore: unknown): boolean {
  const e = errore as { status?: unknown; data?: unknown } | null;
  if (e === null || typeof e !== 'object' || e.status !== 503) return false;
  try {
    return JSON.stringify(e.data ?? null).includes('no_robot_available');
  } catch {
    return false;
  }
}
